import React from 'react';
import { Typography, List, ListItem, ListItemText, Divider } from '@mui/material';

export default function HistorialTimeline({ historial }) {
  if (!historial || historial.length === 0) {
    return <Typography>No hay historial disponible</Typography>;
  }

  return (
    <List>
      {historial.map((h, idx) => (
        <React.Fragment key={h._id || idx}>
          <ListItem>
            <ListItemText
              primary={`Estado: ${h.estado}`}
              secondary={`Fecha: ${new Date(h.fecha).toLocaleDateString()} ${new Date(h.fecha).toLocaleTimeString()} ${
                h.actualizadoPor ? ` | Actualizado por: ${h.actualizadoPor}` : ''
              }`}
            />
          </ListItem>
          <Divider />
        </React.Fragment>
      ))}
    </List>
  );
}